import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Product} from "../../models/product";
import {Router} from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { CouponDialogComponent } from '../../../coupon-dialog/coupon-dialog.component';
import { UserService } from '../../../service/UserService';


@Component({
  selector: 'app-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss']
})
export class GridViewComponent implements OnInit {

  @Input() productList: any;
  @Input() searchKey: any;
  @Output() addItems: EventEmitter<any> = new EventEmitter();
  @Output() viewProduct: EventEmitter<Product> = new EventEmitter();
  
  private readonly WELCOME_PROMO_CODE_ID = 'NEW-CLIENT';
  
  @Input() p: number = 1; 
  @Output() pageChange = new EventEmitter<number>(); 
    
  // 💡 Elimina la inyección de MatDialog y UserService si ya no las necesitas en este componente
  constructor(private router: Router) {
  }

  ngOnInit(): void {
    // 💡 Elimina la llamada para abrir el diálogo de aquí
    // this.checkAndOpenCouponDialog();
  }
  
  // 💡 Elimina estos métodos de este componente
  // checkAndOpenCouponDialog(): void { ... }
  // async openCouponDialog(): Promise<void> { ... }
  

  addToCart(item: string) {
    this.addItems.emit(item);
  }

  viewProductDetail(product: any) {
    this.router.navigate(['/product', product.id], {
      state: { product: product }
    }).then(() => {
      console.log('Navegación completada');
    });
  }

  truncateHtml(text: string, maxLength: number = 100): string {
    const div = document.createElement('div');
    div.innerHTML = text;
    let plainText = (div.textContent || div.innerText || '').replace(/\s+/g, ' ');
    return plainText.length > maxLength 
      ? plainText.substring(0, maxLength) + '...' 
      : plainText;
  }

  getTruncatedDescription(description: string): string {
    return this.truncateHtml(description, 100);
  }
}